export function Loader() {
  return (
    <div className="bg-primary/50 fixed bottom-0 left-0 z-50 h-2 w-full animate-pulse" />
  );
}

export default Loader;
